export default __webpack_public_path__ + "f286941726ba1f37a8cc5a6fb56aa0db.svg";